import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './modal.html',
    styleUrls: ['./modal.scss']
})
export class ModalComponent implements AfterViewInit, OnDestroy, OnChanges {
    @Input() title: string = '';
    @Input() subtitle: string = '';
    @Input() showCancel: boolean = true;
    @Input() showDone: boolean = true;
    @Input() cancelLabel: string = 'Cancel';
    @Input() doneLabel: string = 'Done';
    @Input() isOpen: boolean = false;
    @Input() variant: 'default' | 'investment' = 'default';

    @Output() cancel = new EventEmitter<void>();
    @Output() done = new EventEmitter<void>();
    @Output() close = new EventEmitter<void>();

    @ViewChild('modalElement') modalElement!: ElementRef;
    private modalInstance: any;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['isOpen']) {
            if (this.isOpen) {
                document.body.classList.add('modal-open');
            } else {
                document.body.classList.remove('modal-open');
            }
        }
    }

    ngAfterViewInit() { }

    open() {
        this.isOpen = true;
        document.body.classList.add('modal-open');
    }

    closeModal() {
        this.isOpen = false;
        document.body.classList.remove('modal-open');
        this.close.emit();
    }

    onCancel() {
        this.cancel.emit();
        this.closeModal();
    }

    onDone() {
        this.done.emit();
        this.closeModal();
    }

    ngOnDestroy() {
        document.body.classList.remove('modal-open');
    }
}
